module.exports = __webpack_public_path__ + "img/img-magic-4-b-02-img-01.92f71ea8.png";